import loadable from '@loadable/component';

export const RouteMapLoadable = loadable(() => import('./RouteMapContainer'));
